import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { Avatar, Card, CardContent } from "@mui/material";
import { orange } from "@mui/material/colors";
import AccountBalanceWalletTwoToneIcon from "@mui/icons-material/AccountBalanceWalletTwoTone";

const Balance = () => {
  const [billinginfo, setBillinginfo] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/billingview/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        setBillinginfo(data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <Box sx={{ width: '100%', px: { xs: 1.5, sm: 2 }, py: { xs: 1, sm: 2 } }}>
      <Grid container justifyContent="center">
        <Grid item xs={12} sm={10} md={8} lg={6}>
          <Card sx={{ height: '100%', border: 1, borderColor: 'divider' }}>
            <CardContent>
              <Grid container spacing={{ xs: 1, sm: 2 }} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
                <Grid item>
                  <Typography color="textSecondary" gutterBottom variant="h6" sx={{ fontSize: { xs: '0.95rem', sm: '1rem' } }}>
                    AVAILABLE CREDITS
                  </Typography>
                  <Typography color="textPrimary" variant="h3" sx={{ fontSize: { xs: '1.8rem', sm: '2.2rem' } }}>
                    {`${billinginfo.available}`}
                  </Typography>
                </Grid>
                <Grid item>
                  <Avatar sx={{ backgroundColor: orange[600], height: 56, width: 56 }}>
                    <AccountBalanceWalletTwoToneIcon />
                  </Avatar>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Balance;
